import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "value-cell"
};
const _hoisted_2 = {
  class: "label"
};
const _hoisted_3 = {
  class: "value"
};
export default {
  __name: 'LabelValue',
  props: {
    label: String,
    value: [String, Number]
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(__props.label), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(__props.value), 1)]);
    };
  }
};